import React, { useEffect, useState } from 'react';
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@mui/material';

import { createAcknowledgementBatch } from '../../../endpoints/donations';
import { getApiErrorMessage } from '../../../utils/httpClientTs';

const BATCH_NUMBER_MAX_LEN = 32;

export default function CreateAckBatchDialog({ open, onClose, onCreated }) {
  const [batchNumber, setBatchNumber] = useState('');
  const [creating, setCreating] = useState(false);
  const [errorMsg, setErrorMsg] = useState(null);

  useEffect(() => {
    if (open) {
      setBatchNumber('');
      setErrorMsg(null);
      setCreating(false);
    }
  }, [open]);

  const handleCreate = async () => {
    setCreating(true);
    setErrorMsg(null);
    try {
      const trimmed = batchNumber.trim();
      const res = await createAcknowledgementBatch(
        trimmed ? { batch_number: trimmed } : {}
      );
      onCreated?.(res);
      onClose?.();
    } catch (err) {
      setErrorMsg(getApiErrorMessage(err));
    } finally {
      setCreating(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={creating ? undefined : onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>New acknowledgement batch</DialogTitle>
      <DialogContent>
        {errorMsg && (
          <Alert
            severity="error"
            sx={{ mb: 2 }}
            onClose={() => setErrorMsg(null)}
          >
            {errorMsg}
          </Alert>
        )}
        <TextField
          autoFocus
          fullWidth
          label="Batch number (optional)"
          value={batchNumber}
          onChange={(e) => setBatchNumber(e.target.value)}
          inputProps={{ maxLength: BATCH_NUMBER_MAX_LEN }}
          helperText="Leave blank to auto-generate (e.g. ACK-20260303-abc123). Letters, numbers, dashes, underscores, and periods only."
          disabled={creating}
          sx={{ mt: 1 }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={creating}>
          Cancel
        </Button>
        <Button variant="contained" onClick={handleCreate} disabled={creating}>
          {creating ? 'Creating…' : 'Create batch'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
